import { createFeatureSelector, createSelector } from '@ngrx/store';
import { INewsFeatureStateModel } from '../../models/i-news-feature-state.model';

export const newsFeatureName = 'newsFeature';

export const getNewsStatePage = createFeatureSelector<INewsFeatureStateModel>(newsFeatureName);

export const getNewsState = createSelector(getNewsStatePage, (state) => state.userNews);
